<template>
  <div class="about">
    <p>This app generates all maximized charms of selected combinations of skills in the format that can be used in <a target="_blank" rel="noopener noreferrer" :href="'https://mhrise.wiki-db.com/sim/?hl='+$store.state.lang">Monster Hunter Rise Armorset Search</a>.</p>
    <p>本app用于生成所选技能的所有最大护石组合，以便在 <a target="_blank" rel="noopener noreferrer" :href="'https://mhrise.wiki-db.com/sim/?hl='+$store.state.lang">MHRise配装器</a>中使用.</p>
    <p>Please avoid selecting more than 50 skills at a time, since the armorset search app won't be able to import that large amount of data.</p>
    <p>请不要一次性选择超过50个技能，那个配装器没法导入那么多。</p>
    <h1></h1>
    <br>
    <a target="_blank" rel="noopener noreferrer" href="https://github.com/KrisCris/MHRise-Charm-Generator">source code</a>
  </div>
</template>
